import { Result } from "../../models/general";
import { UserAdjustmentInput, UserAdjustmentView } from "../../models/payroll";
import request from "../../utils/request";

export async function GetUserAdjustmentsPerMonth(userId: string, date: string, currencyId: number) {
    const response = await request.get<Result<UserAdjustmentView[]>>("Adjustment/GetUserAdjustmentsPerMonth", {
        params: { userId, date, currencyId },
    });
    return response.data;
}

export async function UpdateUserAdjustment(input: UserAdjustmentInput) {
    const response = await request.post<Result<UserAdjustmentView>>("Adjustment/UpdateUserAdjustment", input);
    return response.data;
}

export async function DeleteUserAdjustment(id: number) {
    const response = await request.post<Result<UserAdjustmentView>>(`Adjustment/DeleteUserAdjustment/${id}`);
    return response.data;
}

export async function AddUserAdjustment(input: UserAdjustmentInput) {
    const response = await request.post<Result<UserAdjustmentView>>("Adjustment/AddUserAdjustment", input);
    return response.data;
}